const initState = {
  types: [],
  countries: [],
  promos: [],
};

const generalReducer = (state = initState, action: any) => {
  switch (action.type) {
    case "FETCH_TYPES":
      return {
        ...state,
        types: action.payload,
      };
    case "FETCH_PROMOS":
      return {
        ...state,
        promos: action.payload,
      };
    case "FETCH_COUNTRIES":
      return {
        ...state,
        countries: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default generalReducer;
